import { theme } from 'modules/ui';
import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';

import { FooterLogo } from 'modules/ui/logo';
import { SocialLinks } from '../social-links';

export const StyledFooterCopyrightContainer = styled.div`
  width: 100%;
  min-height: 8.375rem;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mediaQuery('md')} {
    justify-content: space-between;
  }
`;

export const StyledFooterLogo = styled(FooterLogo)`
  height: 2.7rem;
`;

export const StyledSocialLinks = styled(SocialLinks)`
  display: none;

  ${mediaQuery('md')} {
    display: flex;
  }
`;

export const StyledFooterHR = styled.div`
  width: 100%;
  ${mediaQuery('md')} {
    border-top: 1px solid ${({theme}) => theme.colors.primaryK1};
  }
`;
